import { rm, NO_ELEMENT } from 'utils';
import styles from './styles.scss';
import cn from 'classnames';

interface TagProps {
  text: string;
  className?: string;
}

export const Tag = ({ text, className }: TagProps) => {
  if (!text) {
    return NO_ELEMENT;
  }

  return (
    <div className={cn(styles.tag, className)}>
      <p>{text}</p>
    </div>
  );
};

export type ProductTags = 'TOP_TESTED' | 'NEW_PRODUCT' | 'POPULAR';

interface IProductTag {
  type?: ProductTags;
  appearance: 'small' | 'large';
  className?: string;
}

type TagOptions = {
  [key in ProductTags]: { text: string; color: string };
};

interface ProductTagKey {
  isTopTested?: boolean;
  isNewProduct?: boolean;
  isPopular?: boolean;
}

type TypeProps = { [key in ProductTags]: boolean };

interface GetTypeProps {
  types: TypeProps;
}

const getType = ({ types }: GetTypeProps): ProductTags => {
  const type = Object.entries(types).find(([, shouldDisplay]) => !!shouldDisplay) as [
    ProductTags,
    boolean
  ];

  return type && type[0];
};

export const getProductTagKey = ({
  isTopTested,
  isNewProduct,
  isPopular
}: ProductTagKey): ProductTags => {
  const types = {
    NEW_PRODUCT: isNewProduct,
    TOP_TESTED: isTopTested,
    POPULAR: isPopular
  } as TypeProps;

  return getType({ types });
};

const tagOptions = {
  TOP_TESTED: {
    text: 'product_toptested_title',
    color: styles.topTested
  },
  NEW_PRODUCT: {
    text: 'product_news_title',
    color: styles.newProduct
  },
  POPULAR: {
    text: 'product_popular_title',
    color: styles.popular
  }
} as TagOptions;

export const ProductTag = ({ type, appearance = 'small', className }: IProductTag) => {
  if (!type) {
    return NO_ELEMENT;
  }

  const { text, color } = tagOptions[type];

  return (
    <Tag
      text={rm(text)}
      className={cn(
        styles.productTag,
        className,
        {
          [styles.tagSmall]: appearance === 'small',
          [styles.tagLarge]: appearance === 'large'
        },
        color
      )}
    />
  );
};
